const DEFAULT_LIGHTLY_HOSTS = [
  "lightly.web.app",
  "church-fundraising-rccg.web.app",
  "localhost",
  "127.0.0.1",
  "::1",
];

function envHosts() {
  const raw = [
    process.env.REACT_APP_PUBLIC_BASE_URL,
    process.env.REACT_APP_LIGHTLY_HOST,
    process.env.REACT_APP_LIGHTLY_HOSTS,
    process.env.REACT_APP_FIREBASE_HOST,
  ]
    .filter(Boolean)
    .join(",");

  return raw
    .split(",")
    .map(normalizeDomain)
    .filter(Boolean);
}

export function normalizeDomain(hostname = "") {
  let value = String(hostname || "").trim().toLowerCase();
  if (!value) return "";

  value = value.replace(/^https?:\/\//, "");
  value = value.split("/")[0] || "";
  value = value.replace(/\.+$/, "");

  if (value.startsWith("[") && value.includes("]")) {
    return value.slice(1, value.indexOf("]"));
  }

  const colonCount = (value.match(/:/g) || []).length;
  if (colonCount === 1) value = value.split(":")[0] || "";
  return value;
}

export function getLookupHostname(hostname = "") {
  const normalized = normalizeDomain(hostname);
  return normalized.startsWith("www.") ? normalized.slice(4) : normalized;
}

export function getCurrentHostname() {
  if (typeof window === "undefined" || !window.location) return "";
  return normalizeDomain(window.location.hostname);
}

export function isLightlyPlatformHost(hostname = getCurrentHostname()) {
  const normalized = getLookupHostname(hostname);
  if (!normalized) return true;
  if (DEFAULT_LIGHTLY_HOSTS.includes(normalized)) return true;
  if (normalized.endsWith(".localhost")) return true;
  if (normalized.endsWith(".web.app")) return true;
  if (normalized.endsWith(".firebaseapp.com")) return true;
  return envHosts().some((host) => host === normalized || getLookupHostname(host) === normalized);
}

export function isLightlyPlatformRoutePath(pathname = "") {
  const root = String(pathname || "")
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)[0];
  return root === "platform" || root === "admin";
}

// Cross-router links on custom-domain hosts use a document load so the target
// starts with a fresh set of tenant/platform providers and guards.
export function requiresFullLoadForPlatformPath(href = "", hostname = getCurrentHostname()) {
  const value = String(href || "");
  if (/^https?:\/\//i.test(value)) return false;
  return !isLightlyPlatformHost(hostname) && isLightlyPlatformRoutePath(value);
}

export function shouldUseCustomDomainPublicRoutes(hostname = getCurrentHostname(), pathname = "") {
  return !isLightlyPlatformHost(hostname) && !isLightlyPlatformRoutePath(pathname);
}

// A custom-domain tab can host either the tenant router or the Lightly
// platform router. Crossing that boundary must reload the document so every
// provider and route guard is rebuilt for the destination context.
export function requiresFullLoadForRouterBoundary(
  href = "",
  hostname = getCurrentHostname(),
  currentPathname = typeof window !== "undefined" ? window.location.pathname : "",
) {
  const value = String(href || "");
  if (/^https?:\/\//i.test(value) || isLightlyPlatformHost(hostname)) return false;

  const targetPathname = value.split("?")[0].split("#")[0] || "/";
  return isLightlyPlatformRoutePath(currentPathname) !== isLightlyPlatformRoutePath(targetPathname);
}

export function getOrgSlugFromPath(pathname = "", hostname = getCurrentHostname()) {
  if (!isLightlyPlatformHost(hostname)) return "";
  const first = String(pathname || "")
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)[0];
  return first ? decodeURIComponent(first) : "";
}
